import c from 'classnames';
import React, { useMemo } from 'react';
import { GetMyAccountQuery } from 'site/graphql';
import { IProfileFields } from './AccountProfile';

type IAccountProfileInputProps = {
    label: string;
    fieldName: IProfileFields;
    autoComplete?: string;
    disabled?: boolean;
    onChange: (fieldName: IProfileFields) => (e: React.ChangeEvent<HTMLInputElement>) => void;
    account: GetMyAccountQuery['myAccount'];
    errors?: any;
    showErrors: boolean;
    classes: Record<'field' | 'field__input' | 'field__inputInvalid', string>;
};

const AccountProfileInput: React.FC<IAccountProfileInputProps> = ({
    classes,
    fieldName,
    label,
    autoComplete,
    disabled,
    onChange,
    account,
    errors,
    showErrors,
}) => {
    const hasFieldError = useMemo(() => {
        if (!errors) {
            return false;
        }

        return errors.has(fieldName);
    }, [fieldName, errors]);

    return (
        <label className={classes.field}>
            {label}
            <input
                type="text"
                onChange={onChange(fieldName)}
                value={account[fieldName] || ''}
                autoComplete={autoComplete}
                className={c(classes.field__input, { [classes.field__inputInvalid]: showErrors && hasFieldError })}
                disabled={disabled}
            />
        </label>
    );
};

export default AccountProfileInput;
